import React from "react";
import { getSignedUrl, lemonadesProductId, mangoLemonadeId, strawberryLemonadeId, topFrozenRecords } from "./FlavorsList";
import { Checkbox } from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";

const FlavorItem = ({
  flv,
  tCount,
  handleSellerCheck,
  categoryIndex,
  scategoryIndex,
  handleAllSellerCheck,
  storeOptionsArray,
  storeOptions,
  allValue,
  catering = false,
}) => {
  const isMangoLemonade = (lemonadesProductId === flv?.intProductTypeID && flv?.intFlavorID === mangoLemonadeId);
  const isStrawberryLemonade = (lemonadesProductId === flv?.intProductTypeID && flv?.intFlavorID === strawberryLemonadeId);

  return (
    <li key={flv?.fid?.toString()} style={{ backgroundColor: lemonadesProductId === flv?.intProductTypeID ? (topFrozenRecords.includes(flv?.intFlavorID) && 'aliceblue') : '' }} >
      <div className={`grid divide-x-0 card-item-style  pl-2`} style={{ gridTemplateColumns: `${catering ? 4 : 1}fr 1.5fr` }}>
        <div
          sx={{
            width: 8 - `${tCount}` / 8,
          }}
          className="w-full pt-3 "
          style={{ display: "flex", paddingLeft: (isMangoLemonade || isStrawberryLemonade) && '10px' }}
        >
          <span
            className="flex-shrink-0 w-7"
            style={{
              // display: "inline-block",
              verticalAlign: "bottom",
            }}
          >
            <img
              className="rounded-full"
              src={getSignedUrl(flv?.thumbnailURL)}
              onError={(event) => {
                event.target.src = "../assets/icons/circle.png";
                event.onerror = null;
              }}
              alt="Flavimage"
            />
            {!catering && <Checkbox
              onChange={(e) =>
                handleSellerCheck(
                  e,
                  categoryIndex,
                  scategoryIndex,
                  flv?.intFlavorID,
                  "favourite",
                  flv?.fid
                )
              }
              checked={flv?.favourite}
              style={{
                position: "absolute",
                marginTop: "-40px",
                marginLeft: "10px",
              }}
              size="small"
              icon={<FavoriteBorder className="text-gray-300 favorite-icon-tour-selector" />}
              checkedIcon={<Favorite color="error" className="favorite-icon-tour-selector" />}
            />}
          </span>
          <span
            style={{
              fontSize: (isMangoLemonade || isStrawberryLemonade) ? "11.5px" : "12.5px",
              paddingLeft: "13px",
              paddingTop: "6px",
            }}
          >
            {flv?.flavor_name}
          </span>
        </div>
        <div
          sx={{
            width: `${tCount}` / 8,
          }}
        >
          <div
            className={`grid mt-2 text-center`}
            style={{
              gridTemplateColumns: `repeat(${
                storeOptionsArray?.length + (catering ? 0 : 1)
              },1fr)`,
            }}
          >
            {!catering && <div>
              <Checkbox
                size="small"
                disabled={flv?.product_type_name === "Flavor Driven Treats"  || isMangoLemonade || isStrawberryLemonade}
                sx={{
                  "&.Mui-disabled": {
                    pointerEvents: "auto",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    cursor: "not-allowed",
                    "& .MuiSvgIcon-root": {
                      // fill: "#FFF",
                      backgroundColor: "#D1D1D1",
                      borderRadius: "25% ",
                    },
                  },
                }}
                checked={allValue}
                onChange={(e) =>
                  handleAllSellerCheck(e, categoryIndex, flv?.intFlavorID)
                }
                style={{
                  color: allValue ? "#1CBF8E" : "#ADB5BD",
                }}
              />
            </div>}
            {storeOptions.web && (
              <div>
                <Checkbox
                  className="web-checkbox-tour-selector"
                  size="small"
                  disabled={
                    flv?.product_type_name === "Flavor Driven Treats"
                      ? true
                      : false
                  }
                  sx={{
                    "&.Mui-disabled": {
                      pointerEvents: "auto",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      cursor: "not-allowed",
                      "& .MuiSvgIcon-root": {
                        // fill: "#FFF",
                        backgroundColor: "#D1D1D1",
                        borderRadius: "25% ",
                      },
                    },
                  }}
                  checked={flv?.web}
                  onChange={(e) =>
                    handleSellerCheck(
                      e,
                      categoryIndex,
                      scategoryIndex,
                      flv?.intFlavorID,
                      "web"
                    )
                  }
                  style={{
                    color: flv?.web ? "#1CBF8E" : "#ADB5BD",
                  }}
                />
              </div>
            )}
            {storeOptions.dmb && (
              <div>
                <Checkbox
                  className="dmb-checkbox-tour-selector"
                  disabled={ flv?.bitLTO || !flv?.bitIsOptional || flv?.product_type_name === "Flavor Driven Treats" || isMangoLemonade || isStrawberryLemonade }
                  sx={{
                    "&.Mui-disabled": {
                      pointerEvents: "auto",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      cursor: "not-allowed",
                      "& .MuiSvgIcon-root": {
                        // fill: "#FFF",
                        backgroundColor: "#D1D1D1",
                        borderRadius: "25% ",
                      },
                    },
                  }}
                  size="small"
                  checked={flv?.dmb}
                  onChange={(e) =>
                    handleSellerCheck(
                      e,
                      categoryIndex,
                      scategoryIndex,
                      flv?.intFlavorID,
                      "dmb"
                    )
                  }
                  style={{
                    color: flv?.dmb ? "#1CBF8E" : "#ADB5BD",
                  }}
                />
              </div>
            )}
            {storeOptions.dt && (
              <div>
                <Checkbox
                  className="dt-checkbox-tour-selector"
                  disabled={ flv?.bitLTO || !flv?.bitIsOptional || flv?.product_type_name === "Flavor Driven Treats" || isMangoLemonade || isStrawberryLemonade }
                  sx={{
                    "&.Mui-disabled": {
                      pointerEvents: "auto",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      cursor: "not-allowed",
                      "& [class*=MuiSvgIcon-root]": {
                        // fill: "#FFF",
                        backgroundColor: "#D1D1D1",
                        borderRadius: "25% ",
                      },
                    },
                  }}
                  size="small"
                  checked={flv?.dt}
                  onChange={(e) =>
                    handleSellerCheck(
                      e,
                      categoryIndex,
                      scategoryIndex,
                      flv?.intFlavorID,
                      "dt"
                    )
                  }
                  style={{
                    color: flv?.dt ? "#1CBF8E" : "#ADB5BD",
                  }}
                />
              </div>
            )}
            {storeOptions.oo && (
              <div>
                <Checkbox
                  className="oo-checkbox-tour-selector"
                  size="small"
                  checked={flv?.oo}
                  onChange={(e) =>
                    handleSellerCheck(
                      e,
                      categoryIndex,
                      scategoryIndex,
                      flv?.intFlavorID,
                      "oo"
                    )
                  }
                  style={{
                    color: flv?.oo ? "#1CBF8E" : "#ADB5BD",
                  }}
                />
              </div>
            )}
            {storeOptions.ct && (
              <div>
                <Checkbox
                  className="ct-checkbox-tour-selector"
                  size="small"
                  checked={flv?.ct}
                  onChange={(e) =>
                    handleSellerCheck(
                      e,
                      categoryIndex,
                      scategoryIndex,
                      flv?.intFlavorID,
                      "ct"
                    )
                  }
                  style={{
                    color: flv?.ct ? "#1CBF8E" : "#ADB5BD",
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default FlavorItem;